import { AxiosRequestConfig } from "axios";
import { removeTokens } from "./LocalStorageHelper";


const homepage ="index.html#/"
export const checkToken = (
  config: AxiosRequestConfig,
  token: string,
  callback: () => void
) => {
  if (token !== null) {
    return callback();
  } else logOutWithNextUrl();
};

export const axiosErrorHandler = (error: any) => {
  if (error.response?.status === 401 && window.location.pathname !== homepage) {
    logOut();
  }
  return Promise.reject(error);
};

export const logOut = () => {
  removeTokens();
  window.location.href = homepage;
};

export const logOutWithNextUrl = () => {
  removeTokens();
  const url = window.location.href;
  window.location.href = url.replace(window.location.origin, "");
};
